"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class CodeNotValidError extends client_library_1.ExtendableError {
    constructor(code) {
        super(`Invalid code: ${code}`);
        this.code = code;
    }
}
exports.default = CodeNotValidError;
//# sourceMappingURL=CodeNotValidError.js.map